import {useState, useEffect} from 'react';

export default function useKeyPress(targetKey: string) {
  const [keyPressed, setKeyPressed] = useState(false);

  const downHandler = (e: KeyboardEvent) => {
    if (targetKey.indexOf('ctrl+') !== -1) {
      // ctrl키 조합했을 경우
      if (e.ctrlKey && e.key === targetKey.replace('ctrl+', '')) {
        setKeyPressed(true);
      }
    } else if (e.key === targetKey) {
      setKeyPressed(true);
    }
  };

  const upHandler = (e: KeyboardEvent) => {
    if (targetKey.indexOf('ctrl+') !== -1) {
      // ctrl키 조합했을 경우
      if (e.ctrlKey && e.key === targetKey.replace('ctrl+', '')) {
        setKeyPressed(false);
      }
    } else if (e.key === targetKey) {
      setKeyPressed(false);
    }
  };

  useEffect(() => {
    window.addEventListener('keydown', downHandler);
    window.addEventListener('keyup', upHandler);

    return () => {
      window.removeEventListener('keydown', downHandler);
      window.removeEventListener('keyup', upHandler);
    };
  }, []);

  return keyPressed;
}
